import WidgetColumn from './widget-column';

export default WidgetColumn;